import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(marketing)/status/page.tsx");
